import expect from '@src/slide/infrastructure/module/independent/assert/expect';

let running = false;
const callbacks: Array<any> = [];

window.addEventListener('resize', (...rest) => {
    if (!running) {
        running = true;

        window.requestAnimationFrame(() => {
            flush(...rest);
            running = false;
        });
    }
}, true);

function compareWidthAndHeight({
    maxHeight, maxWidth, minHeight, minWidth,
}, { width, height }) {
    if (maxHeight && maxHeight < height) return false;
    if (minHeight && minHeight > height) return false;
    if (maxWidth && maxWidth < width) return false;
    if (minWidth && minWidth > width) return false;

    return true;
}

function flush(...rest) {
    const width = window.innerWidth;
    const height = window.innerHeight;

    callbacks
        .filter(({ options }) => {
            // 比对逻辑
            if (!options) return true;
            return compareWidthAndHeight(options, { width, height });
        })
        .forEach(({ cal }) => {
            cal.call(null, ...rest); // eslint-disable-line
        });
}

function compareObj(obj1, obj2) {
    const keys = Object.keys(obj1);
    // @ts-ignore
    if (keys.length !== Object.keys(obj2)) return false;
    return !keys.find(key => (obj1[key] !== obj2[key])); // 找到一个不一样的说明就不同
}

/**
 * 注册
 * @param {*} cal 回调函数
 * @param {*} options.maxHeight optional 最大高度值
 * @param {*} options.minHeight optional 最小高度值
 * @param {*} options.maxWidth optional 最大宽度值
 * @param {*} options.minWidth optional 最小宽度值
 */
export function register(cal, options) {
    callbacks.push({
        cal,
        options,
    });
}

export function remove(cal, options) {
    const c = cal;
    const o = options;
    const index = callbacks.findIndex(({ cal, options }) => {
        if (c !== cal) return false;
        if (expect(o).isBasic() && o === options) return true; // 基础类型比较
        if (compareObj(o, options)) return true; // 对象比较
        return false;
    });

    if (index > -1) {
        callbacks.splice(index, 1);
    }
}
